'use strict';

function isValid(password) {
    if (!password) {
        return true;
    }
    if (password.length < 8) {
        return false;
    }
    if (!/[0-9]/.test(password)) {
        return false;
    }
    if (password.toLowerCase() == password || password.toUpperCase() == password) {
        return false;
    }
    return true;
};


class PasswordDirective {
    restrict = 'A';
    require = 'ngModel';
    scope = {
        validationEnabled: '&password'
    };

    link(scope, element, attrs, ngModelCtrl) {
        ngModelCtrl.$parsers.push(function (viewValue) {
            if (!scope.validationEnabled() !== undefined && !scope.validationEnabled()) {
                return viewValue;
            }
            var valid = isValid(viewValue);
            ngModelCtrl.$setValidity('password', valid);
            if (valid) {
                return viewValue;
            }
            return undefined;
        });

        scope.$watch(
            () => scope.validationEnabled(),
            () => {
                if (!scope.validationEnabled() !== undefined && !scope.validationEnabled()) {
                    ngModelCtrl.$setValidity('password', true);
                } else {
                    ngModelCtrl.$setValidity('password', isValid(ngModelCtrl.$viewValue));
                }
            }
        );
    }
}

export default () => new PasswordDirective();


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/validation/password.directive.js